var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123,
    height: 122.999,
    viewBox: "0 0 123 122.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 123,
    height: 122.999,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.306
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4311,1222a26.834,26.834,0,0,1-10.51-2.122,26.907,26.907,0,0,1-8.582-5.786,26.917,26.917,0,0,1-5.787-8.582A26.836,26.836,0,0,1-4338,1195a26.836,26.836,0,0,1,2.122-10.51,26.917,26.917,0,0,1,5.787-8.582,26.907,26.907,0,0,1,8.582-5.786A26.834,26.834,0,0,1-4311,1168a26.834,26.834,0,0,1,10.509,2.122,26.908,26.908,0,0,1,8.582,5.786,26.9,26.9,0,0,1,5.787,8.582A26.836,26.836,0,0,1-4284,1195a26.836,26.836,0,0,1-2.122,10.51,26.9,26.9,0,0,1-5.787,8.582,26.908,26.908,0,0,1-8.582,5.786A26.834,26.834,0,0,1-4311,1222Zm-8.25-38.249h0v22.5L-4296,1195l-23.249-11.25Z",
    transform: "translate(4372.5 -1136.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.64bb6c6ed77b115be542b11cc8191b14.svg";
export { ForwardRef as ReactComponent };